/**
 * Handle search takeover behaviors
 */
const SearchTakeover = {
	searchActive: false,
	/**
	 * Entry point
	 */
	_init: () => {
		// listen for document ready
		document.addEventListener('DOMContentLoaded', SearchTakeover._ready);
	},
	/**
	 * Fired when document ready
	 */
	_ready: () => {
		// store ref to takeover el
		SearchTakeover.takeover = document.querySelector('.searchtakeover');

		// Media query for screen size change.
		const mq = window.matchMedia('(min-width: 1200px)');

		// Check initial screen size and then add event listener.
		if (mq.matches) {
			document.addEventListener(
				'pointermove',
				SearchTakeover._closeButtonMoveHandler
			);
		}

		// listen for search input changes
		const searchInput = document.querySelector('.searchtakeover-form-label-input');
		if (searchInput instanceof HTMLElement) {
			searchInput.addEventListener('input', SearchTakeover._searchInputChangeHandler);
		}

		// listen for nav magnifying glass click
		const takeoverToggle = document.querySelector('.pammheader-grid-primary-extra-search a');
		if (takeoverToggle instanceof HTMLElement) {
			takeoverToggle.addEventListener('click', SearchTakeover._takeoverToggleClickHandler);
		}

		// listen for search takeover close click
		const takeoverClose = document.querySelector('.searchtakeover-close');
		if (takeoverClose instanceof HTMLElement) {
			takeoverClose.addEventListener('click', SearchTakeover._takeoverCloseClickHandler);
		}

		
	},
	/**
	 * Handle the search/submit icons changing on search input
	 * @param {object} e the event object
	 */
	_searchInputChangeHandler: (e) => {
		const searchIcon = document.querySelector('.searchtakeover-form-submit-icon.search');
		const submitIcon = document.querySelector('.searchtakeover-form-submit-icon.submit');
		if (e.target.value.length > 0) {
			searchIcon.classList.remove('active');
			submitIcon.classList.add('active');
		}
		else {
			submitIcon.classList.remove('active');
			searchIcon.classList.add('active');
		}
	},
	/**
	 * Add the active class to the search takeover object
	 * @param {object} e the event object
	 */
	_takeoverToggleClickHandler: (e) => {
		// no # in url
		e.preventDefault();

		const pammGrid = document.querySelector(
			'header.wp-block-template-part'
		);
		const pammGridSecondary = document.querySelector('.pammheader-grid-secondary');
		const pammGridLogo = document.querySelector('.pammheader-grid-logo');

		const navTakeover = document.querySelector('.takeover-nav');
		if (SearchTakeover.takeover instanceof HTMLElement) {
			SearchTakeover.searchActive = true;
			SearchTakeover.takeover.classList.add('active');
			navTakeover.classList.add('submenu-open');
			pammGrid.classList.remove('hidden');
			pammGridLogo.classList.remove('hidden');
			pammGridSecondary.classList.remove('hidden');

			pammGrid.classList.add('submenu-open');
		}
	},
	/**
	 * Remove the active class to the search takeover object
	 * @param {object} e the event object
	 */
	_takeoverCloseClickHandler: (e) => {
		// no # in url
		e.preventDefault();

		const pammGrid = document.querySelector(
			'header.wp-block-template-part'
		);
		const navTakeover = document.querySelector('.takeover-nav');
		
		if (SearchTakeover.takeover instanceof HTMLElement) {
			SearchTakeover.searchActive = false;
			SearchTakeover.takeover.classList.remove('active');
			navTakeover.classList.remove('submenu-open');
			pammGrid.classList.remove('submenu-open');
		}
	},
	/**
	 * Handle the movement of the close button.
	 * @param {object} e the event object.
	 */
	_closeButtonMoveHandler: (e) => {
		if (!SearchTakeover.searchActive) return;

		const { clientX, clientY } = e;

		const closeButton = document.querySelector(
			'.searchtakeover-close'
		);

		const inHeader = e.target.closest('header.wp-block-template-part');
		const inInput = e.target.closest('.searchtakeover-form');

		if (inHeader || inInput) {
			closeButton.style.visibility = 'hidden';
		} else {
			closeButton.style.visibility = 'visible';
		}

		const closeButtonRect = closeButton.getBoundingClientRect();

		closeButton.style.top = `${clientY - closeButtonRect.height / 2}px`;
		closeButton.style.left = `${clientX - closeButtonRect.width / 2}px`;
	},
}

// beg inn.
SearchTakeover._init();